import { render, staticRenderFns } from "./UploadVideo.vue?vue&type=template&id=6819dffa"
import script from "./UploadVideo.vue?vue&type=script&lang=js"
export * from "./UploadVideo.vue?vue&type=script&lang=js"
import style0 from "./UploadVideo.vue?vue&type=style&index=0&id=6819dffa&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6819dffa')) {
      api.createRecord('6819dffa', component.options)
    } else {
      api.reload('6819dffa', component.options)
    }
    module.hot.accept("./UploadVideo.vue?vue&type=template&id=6819dffa", function () {
      api.rerender('6819dffa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UploadVideo.vue"
export default component.exports